import { render } from "./CoverStyle.vue?vue&type=template&id=3babca97"
const script = {}

import "./CoverStyle.vue?vue&type=style&index=0&id=3babca97&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__